import { Observable } from "rxjs";
import { CalendarGetQueryResult } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export interface ICalendarService {

  calendarGet(fromDate: Date, toDate: Date, countryCode: string): Observable<CalendarGetQueryResult>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ICalendarServiceToken = new InjectionToken<ICalendarService>('ICalendarServiceToken');
